/* Verona Tempo r12: calmer menu dropdowns on computers (hover intent) and small header helpers.
   See REVAMP-LOG.md "Round 12". Runs after vt-theme.js and vt-r10.js (deferred scripts run in page order). */
(function () {
  'use strict';
  var html = document.documentElement;
  var onReady = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  /* ---- hover intent for the menu dropdowns (Theme settings > Verona Tempo > "Calmer menu dropdowns") --------
     Symmetry opened a panel the moment the pointer touched a menu word and closed it 250 ms after it left. Now:
     - a panel opens only when the pointer rests on its word for 120 ms (passing over other words on the way down to
       an open panel does nothing);
     - it closes 250 ms after the pointer has left BOTH the word and the panel (a generous hit area under the word,
       .vt-dd-open::after in vt-r12.css, bridges the gap between word and panel);
     - moving from one open panel's word to another switches straight away after the same 120 ms.
     Only real mouse events on pointers that can hover are taken over (stopped before Symmetry sees them).
     Keyboard (Enter/Space/arrows), the small arrow button, touch and Esc/outside click still go through Symmetry and
     vt-r10.js exactly as before: those use synthetic events, which pass through untouched. */
  function initHoverIntent() {
    if (!html.classList.contains('vt-r12-dd') || !html.classList.contains('vt-r10-dd')) return;
    var proxy = document.getElementById('proxy-nav');
    var mainNav = document.getElementById('main-nav');
    if (!proxy || !mainNav) return;
    var proxyItems = Array.prototype.slice.call(proxy.querySelectorAll('.navigation__tier-1 > .navigation__item'));
    var realItems = Array.prototype.slice.call(mainNav.querySelectorAll('.navigation__tier-1 > .navigation__item'));
    if (!proxyItems.length || proxyItems.length !== realItems.length) return;
    var header = document.querySelector('.section-header');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 250;
    var OPEN = 'navigation__item--show-children';
    var hasPanel = function (i) { return realItems[i].classList.contains('navigation__item--with-children'); };
    var isOpen = function (i) { return realItems[i].classList.contains(OPEN); };
    var openIndex = function () { for (var i = 0; i < realItems.length; i++) if (isOpen(i)) return i; return -1; };
    var over = -1; // where the pointer is: index of a word or its panel, -1 = elsewhere
    var openTimer = 0;
    var closeTimer = 0;
    var pointerY = 0;
    proxy.addEventListener('mousemove', function (e) { pointerY = e.clientY; }, { passive: true });

    var clearSymmetryTimers = function (el) {
      window.clearTimeout(+el.dataset.navCloseTimeoutId || 0);
      window.clearTimeout(+el.dataset.navOpenTimeoutId || 0);
    };
    var closeNow = function (i) {
      var el = realItems[i];
      clearSymmetryTimers(el);
      el.classList.remove(OPEN);
      if (el.firstElementChild) el.firstElementChild.setAttribute('aria-expanded', 'false');
      if (openIndex() < 0 && header) header.classList.remove('section-header--nav-open');
    };
    var openNow = function (i) {
      realItems.forEach(function (el, j) { if (j !== i && isOpen(j)) closeNow(j); });
      if (window.vtR10Dd && window.vtR10Dd.place) window.vtR10Dd.place(i);
      clearSymmetryTimers(realItems[i]);
      // no other panel is open now, so Symmetry opens this one at once (its own 250 ms delay is for switching)
      realItems[i].dispatchEvent(new Event('mouseenter'));
      realItems[i].dataset.vtOpenedAt = String(Date.now());
    };
    var enter = function (i) {
      over = i;
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      if (!hasPanel(i)) {
        // a word without a panel: close what is open after the grace time (unless she goes back to it)
        if (openIndex() >= 0) closeTimer = window.setTimeout(function () { var o = openIndex(); if (o >= 0 && over !== o) closeNow(o); }, CLOSE_DELAY);
        return;
      }
      if (isOpen(i)) return;
      var y0 = pointerY;
      var tryOpen = function () {
        if (over !== i) return;
        // diagonal-safe: while another panel is open and the pointer is still heading down towards it, wait a bit more
        if (openIndex() >= 0 && pointerY - y0 > 3) { y0 = pointerY; openTimer = window.setTimeout(tryOpen, OPEN_DELAY); return; }
        openNow(i);
      };
      openTimer = window.setTimeout(tryOpen, OPEN_DELAY);
    };
    var leave = function (i) {
      if (over === i) over = -1;
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        var o = openIndex();
        if (o < 0 || over === o) return;
        // keyboard focus inside the panel keeps it open
        if (realItems[o].contains(document.activeElement) && document.activeElement !== document.body) return;
        if (over >= 0 && hasPanel(over)) return; // her pointer rests on another word: that one opens instead
        closeNow(o);
      }, CLOSE_DELAY);
    };

    // words (proxy menu) and the real items (they hold the panels): take over real mouse enter/leave
    var intercept = function (list) {
      return function (e) {
        if (!e.isTrusted || !canHover.matches) return;
        var i = list.indexOf(e.target);
        if (i < 0) return;
        if (!hasPanel(i) && list === realItems) return;
        e.stopPropagation();
        if (e.type === 'mouseenter') enter(i); else leave(i);
      };
    };
    var onProxy = intercept(proxyItems);
    var onReal = intercept(realItems);
    proxy.addEventListener('mouseenter', onProxy, true);
    proxy.addEventListener('mouseleave', onProxy, true);
    mainNav.addEventListener('mouseenter', onReal, true);
    mainNav.addEventListener('mouseleave', onReal, true);

    // the open word gets .vt-dd-open (underline + the hit area that bridges down to its panel), whatever opened it
    var sync = function () { proxyItems.forEach(function (item, i) { item.classList.toggle('vt-dd-open', isOpen(i)); }); };
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      realItems.forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    }
    html.classList.add('vt-r12-dd-js');
  }

  onReady(function () {
    [initHoverIntent].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.warn('vt-r12', fn.name, e); }
    });
  });
})();
